export default {
	apiKey: "AIzaSyArsJLri2Ty9QO7cPuib9jV-r0H3UoyQbs",
	authDomain: "ivelop.me",
	projectId: "ivelop-dbe68",
	storageBucket: "ivelop-dbe68.appspot.com",
	messagingSenderId: "699256212804",
	appId: "1:699256212804:web:12da5f6096ac748f051b11"
}